module.exports = __webpack_public_path__ + "static/ah-ah-ah-14a540f30278f55841556055ce003fc5.mp3";